import React from 'react';
import AccountPayment from '../../../components/AccountPayment';

const AccountPaymentUser: React.FC = () => {
  return (
    <AccountPayment />
  )
};

export { AccountPaymentUser };